<!-- 自定义纵向滚动 -->
<template>
  <div ref="scrollView" @mousedown="onMousedownScrollView($event)" @touchstart="onTouchstartScrollView($event)"
    @touchmove="onTouchmoveScrollView($event)" @touchend.stop="isShowScrollBar = false" class="scrollView"
    :isMobile="isMobile">
    <div ref="scrollContent" :style="{ transform: 'translateY(' + translateY + 'px)' }">
      <slot></slot>
    </div>
    <div :style="scrollBarStyle" @mousedown.stop="onMousedownScrollBar($event)"
      @touchstart.stop="onTouchstartScrollBar($event)" @touchmove.stop="onTouchmoveScrollBar($event)"
      @touchend.stop="isShowScrollBar = false" :class="{ 'isShow': isShowScrollBar }" class="scrollBar"></div>
  </div>
</template>

<script>
  export default {
    props: {
      isOpenMouseEvent: {
        type: Boolean,
        default: false
      },
    },
    name: 'scrollView',
    data() {
      return {
        isMobile: 0, //1移动端 0 pc端
        scrollHeight: 0, //内容总宽度
        offsetHeight: 0, //组件可见宽度
        maxTranslateY: 0, //组件最小偏移量
        scrollBarMaxScroll: 0, //滚动条运行滚动的最大值
        scrollBarHeight: 0, //滚动条高度
        translateY: 0, //组件当前偏移量
        offsetY: 0, //记录鼠标按下时的Y
        isShowScrollBar: false,
        scrollBarStyle: {
          height: "0px",
          top: "0px"
        }
      }
    },
    created() {
      this.isMobile = this.getMobile() ? 1 : 0;
    },
    mounted() {
      this.bus.$on('onResize', this.onResize);
      //绑定滚动事件
      this.$refs.scrollView.onwheel = this.onMousewheel;
      this.calculation();
    },
    beforeDestroy() { //组件销毁
      this.bus.$off('onResize', this.onResize);
    },
    methods: {
      // 判断是否是移动端
      getMobile() {
        let sUserAgent = navigator.userAgent.toLowerCase();
        if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
          return true;
        } else {
          return false;
        }
      },
      onMousewheel(event) {
        this.calculation();
        console.log(event.deltaY)
        let moveY = -30;
        if (event.deltaY < 0) {
          moveY = 30;
        }
        if (this.maxTranslateY != 0) {
          let translateY = this.translateY + moveY;
          if (translateY > 0) {
            translateY = 0;
          } else if (translateY < this.maxTranslateY) {
            translateY = this.maxTranslateY;
          }
          if (this.translateY != translateY) {
            if (event.preventDefault) {
              // Firefox
              event.preventDefault();
              event.stopPropagation();
            } else {
              // IE
              event.cancelBubble = true;
              event.returnValue = false;
            }
            this.scroll(moveY);
          }
          this.offsetY = 0;
        }
      },
      /**
       * 计算一些高度
       */
      calculation() {
        this.offsetHeight = this.$refs.scrollView.offsetHeight;
        this.scrollHeight = this.$refs.scrollView.scrollHeight;
        this.maxTranslateY = this.offsetHeight - this.scrollHeight;
        if (this.maxTranslateY != 0) {
          this.scrollBarHeight = this.offsetHeight / (this.scrollHeight / this.offsetHeight);
          this.scrollBarMaxScroll = this.offsetHeight - this.scrollBarHeight;
          this.scrollBarStyle.height = this.scrollBarHeight + "px";
        } else {
          this.scrollBarStyle.height = 0;
        }
      },
      onResize() {
        this.calculation();
        if (this.maxTranslateY == 0) {
          this.scrollYTo(0);
        } else if (this.translateY < this.maxTranslateY) {
          this.scrollYTo(this.maxTranslateY);
        }
      },
      /**
       * 监听手指在组件上按下
       * @param {Object} event 事件对象
       */
      onTouchstartScrollView(event) {
        this.isShowScrollBar = true;
        this.offsetY = event.touches[0].clientY;
      },
      /**
       * 监听手指在组件上滑动
       * @param {Object} event 事件对象
       */
      onTouchmoveScrollView(event) {
        event.preventDefault();
        event.stopPropagation();
        let clientY = event.touches[0].clientY; //鼠标的Y坐标
        this.scroll(clientY - this.offsetY);
        this.offsetY = clientY;
      },
      /**
       * 监听鼠标在组件上按下
       * @param {Object} event
       */
      onMousedownScrollView(event) {
        if (!this.isOpenMouseEvent) return;
        if (event.buttons != 1) return;
        this.offsetY = event.clientY;
        window.addEventListener("mouseup", this.onMouseupScrollView);
        window.addEventListener("mousemove", this.onMousemoveScrollView);
      },
      /**
       * 鼠标在组件上移动
       * @param {Object} event
       */
      onMousemoveScrollView(event) {
        if (event.buttons == 1) {
          let clientY = event.clientY; //鼠标的Y坐标
          this.scroll(clientY - this.offsetY);
          this.offsetY = clientY;
        } else {
          this.onMouseup();
        }
      },
      /**
       * 鼠标在组件上松开
       */
      onMouseupScrollView() {
        window.removeEventListener("mouseup", this.onMouseupScrollView);
        window.removeEventListener("mousemove", this.onMousemoveScrollView);
      },
      /**
       * 监听鼠标在滚动条上按下
       * @param {Object} event
       */
      onMousedownScrollBar(event) {
        if (event.buttons != 1) return;
        this.offsetY = event.clientY;
        window.addEventListener("mouseup", this.onMouseupScrollBar);
        window.addEventListener("mousemove", this.onMousemoveScrollBar);
      },
      /**
       * 鼠标在滚动条上移动
       */
      onMousemoveScrollBar(event) {
        if (event.buttons == 1) {
          let clientY = event.clientY;
          let offsetY = clientY - this.offsetY; //鼠标移动的Y坐标
          let scrollBarTop = this.scrollBarStyle.top.replace("px", "") * 1;
          scrollBarTop = scrollBarTop + offsetY;
          if (scrollBarTop < 0) {
            scrollBarTop = 0;
          } else if (scrollBarTop > this.scrollBarMaxScroll) {
            scrollBarTop = this.scrollBarMaxScroll;
          }
          this.scrollBarStyle.top = scrollBarTop + "px";
          this.setScrollByScrollBar(scrollBarTop);
          this.offsetY = clientY;
        } else {
          this.onMouseupScrollBar();
        }
      },
      /**
       * 鼠标在滚动条上松开
       * @param {Object} event
       */
      onMouseupScrollBar(event) {
        window.removeEventListener("mouseup", this.onMouseupScrollBar);
        window.removeEventListener("mousemove", this.onMousemoveScrollBar);
      },
      /**
       * 监听手指在滚动条上按下
       * @param {Object} event
       */
      onTouchstartScrollBar(event) {
        this.isShowScrollBar = true;
        this.offsetY = event.touches[0].clientY;
      },
      /**
       * 监听手指在滚动条上滑动
       * @param {Object} event
       */
      onTouchmoveScrollBar(event) {
        let clientY = event.touches[0].clientY;
        let offsetY = clientY - this.offsetY; //鼠标移动的Y坐标
        let scrollBarTop = this.scrollBarStyle.top.replace("px", "") * 1;
        scrollBarTop = scrollBarTop + offsetY;
        if (scrollBarTop < 0) {
          scrollBarTop = 0;
        } else if (scrollBarTop > this.scrollBarMaxScroll) {
          scrollBarTop = this.scrollBarMaxScroll;
        }
        this.scrollBarStyle.top = scrollBarTop + "px";
        this.setScrollByScrollBar(scrollBarTop);
        this.offsetY = clientY;
      },
      /**
       * 根据滚动条的位置来设置组件滚动距离
       */
      setScrollByScrollBar(scrollBarTop) {
        this.translateY = this.maxTranslateY * (scrollBarTop / this.scrollBarMaxScroll);
      },
      /**
       * @param {Object} scrollY 偏移量
       */
      scroll(scrollY) {
        // 计算位移坐标
        let translateY = this.translateY + scrollY;
        if (translateY > 0) {
          translateY = 0;
        } else if (translateY < this.maxTranslateY) {
          translateY = this.maxTranslateY;
        }
        this.translateY = translateY;
        if (this.scrollBarStyle.height != 0) {
          this.scrollBarStyle.top = Math.abs(this.translateY) / Math.abs(this.maxTranslateY) * this
            .scrollBarMaxScroll +
            "px";
        }
      },
      /**
       * 移动到某处
       * @param {Object} scrollY
       */
      scrollYTo(scrollY) {
        this.translateY = scrollY;
        this.offsetY = 0;
        if (this.scrollBarStyle.height != 0) {
          this.scrollBarStyle.top = Math.abs(this.translateY) / Math.abs(this.maxTranslateY) * this
            .scrollBarMaxScroll +
            "px";
        }
      },
      /**
       * 滚动到底部
       */
      scrollToBottom() {
        this.calculation();
        this.scrollYTo(this.maxTranslateY);
      },
      // 获取滚动条偏移量
      getTranslateY() {
        return this.translateY;
      }
    }
  }
</script>

<style scoped>
  .scrollView {
    user-select: none;
    overflow: hidden;
    position: relative;
  }

  .scrollView .scrollBar {
    right: 0;
    position: absolute;
    opacity: 0;
    transition: opacity 1s;
    width: 6px;
    background-color: #e2e4e9;
    border-radius: 3px;
    cursor: pointer;
  }

  .scrollView[isMobile='0']:hover .scrollBar,
  .scrollView .scrollBar.isShow {
    opacity: 1;
  }
</style>


// WEBPACK FOOTER //
// src/components/scrollView/scrollView.vue